import script from "./AgentStepReview.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentStepReview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import WizardIcon from "@/components/neue/wizard/WizardIcon.vue";
script.components = Object.assign({}, { WizardIcon }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { WizardIcon }, script.__o.components);}